import React from 'react';
import Loader from '../../components/common/Loader';
import Footer from '../../components/common/Footer';
import Menu from '../../components/common/Menu';
import Navbar from '../../components/common/Navbar';
import StartButton from '../../components/home/StartButton';
import FloatingCheckoutButton from '../../components/common/FloatingCheckoutButton';
import Header from '../../components/innerpage/products/Header';
import ProductsList from "../../components/innerpage/products/ProductsList";
import {Helmet} from 'react-helmet';
import { usePageLoader } from '../../hooks/usePageLoader';

const ProductsPage: React.FC = () => {
    usePageLoader(); // Hide loader on mount for client-side navigation

    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://tempefab.com/products"/>
                <title>Products | Tempe Fabrication | Custom Metal Products</title>
                <meta name="description"
                      content="Explore our range of custom metal fabrication products including railings, gates, furniture, signs, and architectural metalwork in Tempe, Arizona."/>
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="/home/assets/css/home_1_style.css"
                />
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="/innerpages/assets/css/innerpages.css"
                />
                <script src="/common/assets/js/common_js.js"></script>
                <script src="/innerpages/assets/js/innerpages.js"></script>
            </Helmet>
            <div className="inner-pages-style1 products-pg-style1">
            <Loader/>
            <Menu/>
            <div className="smooth-scroll-content" id="scrollsmoother-container">
                <Navbar currentPage="products"/>
                <Header/>
                <ProductsList/>
                <main>
                    {/* Add your products page content here */}
                </main>
                <Footer/>
            </div>
            <StartButton/>
            <FloatingCheckoutButton/>
            </div>
        </>
    );
}

export default ProductsPage;
